import React from 'react';
import HttpRequest from 'helper-xhr';

import { Localize } from "./localize.js";

class UserJoin extends React.Component {
  static displayName = "join-complete";

  state = {
    user: {
      email: '',
      password: '',
      name: "",
      company: "",
      phone: ""
    },
    ui: {
      email: null,
      password: -1,
      name: null,
      company: null,
      phone: null,

      clickedJoinNow: false,
      isSaving: false,
      isSendingPassword: false,
      isSentPassword: false,
      emailAlreadyExist: false,

      signedUp: false
    }
  };

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  scorePassword = (pass) => {
    var score = 0;
    if (!pass)
      return score;

    // award every unique letter until 5 repetitions
    var letters = new Object();
    for (var i = 0; i < pass.length; i++) {
      letters[pass[i]] = (letters[pass[i]] || 0) + 1;
      score += 5.0 / letters[pass[i]];
    }

    // bonus points for mixing it up
    var variations = {
      digits: /\d/.test(pass),
      lower: /[a-z]/.test(pass),
      upper: /[A-Z]/.test(pass),
      nonWords: /\W/.test(pass),
    }

    let variationCount = 0;
    for (var check in variations) {
      variationCount += (variations[check] === true) ? 1 : 0;
    }
    score += (variationCount - 1) * 10;

    return parseInt(score);
  }

  onChangeValue = (field, e) => {
    var newValue = e.target.value;
    var ui = Object.assign({}, this.state.ui);
    var user = Object.assign({}, this.state.user);
    user[field] = newValue;

    switch (field) {
      case "email":
        if (this.state.ui.email === false) {
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          ui.email = re.test(newValue);
        }
        break;
      case "password":
        newValue = newValue.trim();
        if (!!newValue) {
          ui.password = this.scorePassword(newValue);
        }
        break;

      default:
        break;
    }

    this.setState({
      user: user,
      ui: ui
    });
  };

  onBlurValue = (field, e) => {
    var newValue = e.target.value.trim();
    var ui = Object.assign({}, this.state.ui);

    switch (field) {
      case "email":
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        ui.email = re.test(newValue);
        break;
      case "password":
        newValue = newValue.trim();
        if (!!newValue) {
          ui.password = scorePassword(newValue);
        }
        break;

      default:
        break;
    }

    this.setState({
      ui: ui
    });
  };

  redirectToLoginPage = () => {
    window.location.href = "/login";
  };

  sendMeMyPassword = (e) => {
    var ui = Object.assign({}, this.state.ui);

    if (ui.email) {
      ui.isSendingPassword = true;

      var xhr = new HttpRequest("POST", '/api/sendpassword', "application/json");
      xhr.send(this.state.user)
        .then((response) => {
          var json = response.json;
          if (json.message || json.exception || json.error) {
            //throw Error(json.message || json.exception || json.error);
          }

          var ui = Object.assign({}, this.state.ui, {
            isSendingPassword: false,
            isSentPassword: true
          });
          if (json.errors) {
            //ui.emailAlreadyExist = !!(d.errors.find((e,i,a)=> (e.code=="email-in-use")));
          } else {
            //setTimeout(() => this.redirectToLoginPage(), 2000);
          }
          this.setState({
            ui: ui
          });

        }, (error) => {
          //dispatch(cartIsLoading(false));
          //dispatch(getCart_FAIL(error));
        });
    }

    this.setState({
      ui: ui
    });
  };

  onJoinNow = (e) => {
    var ui = Object.assign({}, this.state.ui, {
      clickedJoinNow: true,
      email: this.state.ui.email === null ? false : this.state.ui.email,
      password: this.state.ui.password === -1 ? 0 : this.state.ui.password
    });

    if (ui.email && ui.password >= 30) {
      ui.password = 101;
      ui.isSaving = true;

      var xhr = new HttpRequest("POST", '/api/signup', "application/json");
      return xhr.send(this.state.user)
        .then((response) => {
          var json = response.json;
          if (json.message || json.exception || json.error) {
            //throw Error(json.message || json.exception || json.error);
          }
          var ui = Object.assign({}, this.state.ui, {
            isSaving: false
          });
          if (json.errors) {
            ui.emailAlreadyExist = !!(json.errors.find((e, i, a) => (e.code == "email-in-use")));
          } else {
            //window.location.href = "/";
            //success user successfully signed up
            ui.signedUp = true;
          }
          this.setState({
            ui: ui
          });
          //return response;
        }, (error) => {
          //dispatch(cartIsLoading(false));
          //dispatch(getCart_FAIL(error));
        });
    }

    this.setState({
      ui: ui
    });

  };

  render() {

    console.log(this.constructor.displayName, "rendering!");
    var emailErrorMsg = null;
    var passwordMsg = null;

    if (this.state.ui.signedUp) {
    } else {
      if (this.state.ui.isSendingPassword) {
        emailErrorMsg =
          <span className="help-block">
          <span className="badge badge-danger">{Localize.L("Questo indirizzo email è già utilizzato")}.</span> {Localize.L("Vuoi che ti inviamo la password associata a questa email?")} <button className="btn btn-link disabled"><strong><i className="fa fa-cog fa-spin fa-fw"></i> {Localize.L("Sending")}...</strong></button>
          </span>;
      } else if (this.state.ui.isSentPassword) {
        emailErrorMsg =
          <span className="help-block">
          <span className="badge badge-danger">{Localize.L("Questo indirizzo email è già utilizzato")}.</span> {Localize.L("Vuoi che ti inviamo nuovamente la password?")} <button className="btn btn-link disabled"><strong><i className="fa fa-check fa-fw"></i> {Localize.L("Inviata! Controlla la posta")}.</strong></button>
          </span>;
      } else if (!!this.state.ui.emailAlreadyExist && !this.state.ui.isSendingPassword) {
        emailErrorMsg =
          <span className="help-block">
          <span className="badge badge-danger">{Localize.L("Questo indirizzo email è già utilizzato")}.</span> {Localize.L("Vuoi che ti inviamo la password?")} <a href="#" className="orange-link" style={{ fontFamily: "Roboto Condensed" }} onClick={(e) => this.sendMeMyPassword(e)}><strong>{Localize.L("Si, per favore, inviatemi la password!")}</strong></a>
          </span>;
      } else if (!(this.state.ui.email === null)) {
        emailErrorMsg = (!this.state.ui.email ? <span className="help-block badge badge-danger">{Localize.L("Email is not valid")}.</span> : null);
      }
      if (this.state.ui.password >= 0 && this.state.ui.password < 30) {
        passwordMsg = <span className="help-block badge badge-danger">{Localize.L("Troppo facile da scoprire! Scegli una password più complessa")}.</span>;
      } else if (this.state.ui.password >= 30 && this.state.ui.password <= 60) {
        passwordMsg = <span className="help-block badge badge-warning">{Localize.L("Facile da scoprire! Che ne dici di scegliere una password migliore?")}</span>;
      } else if (this.state.ui.password > 60 && this.state.ui.password <= 100) {
        passwordMsg = <span className="help-block badge badge-success">{Localize.L("Ok! Questa password è sicura")}.</span>;
      }
    }

    var joinBtnText = <span>{Localize.L("Join now!")}</span>;
    var joinBtnMsg = null;
    if (this.state.ui.signedUp) {
      joinBtnText = <span><i className="fas fa-check"></i> {Localize.L("Joined!")}</span>;
      joinBtnMsg = <div style={{ paddingTop: 20, fontWeight: 700 }}>{Localize.L("Adesso puoi effettuare il login con la password che hai scelto")}.</div>;
    } else {
      if (this.state.ui.clickedJoinNow && !this.state.ui.email) {
        joinBtnMsg = <span className="help-block badge badge-danger" style={{ marginRight: "10px" }}><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> {Localize.L("Please check the email address")}.</span>;
      } else if (this.state.ui.clickedJoinNow && this.state.ui.password < 30) {
        joinBtnMsg = <span className="help-block badge badge-danger"><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> {Localize.L("Plese enter a reasonably secure password")}.</span>;
      }
    }
    //<div className="form-group">
    //  <label>Full name <span style={{ color: "#888", fontWeight: "normal" }}>(optional but appreciated)</span></label>
    //  <input type="text" className="form-control" placeholder="Name" value={this.state.user.name} onChange={(e, value) => this.onChangeValuen("name", e)} />
    //</div>
    //  <div className="form-group">
    //    <label>Company name <span style={{ color: "#888", fontWeight: "normal" }}>(optional but appreciated)</span></label>
    //    <input type="text" className="form-control" placeholder="Company" value={this.state.user.company} onChange={(e, value) => this.onChangeValuen("company", e)} />
    //  </div>

    return (
      <fieldset className="join" disabled={this.state.ui.signedUp}>
        <div className={"form-group " + (this.state.ui.email === null ? "" : (!this.state.ui.email ? "has-error" : ""))}>
          <label>{Localize.L("Indirizzo Email")}</label>
          <input type="email" className="form-control" placeholder="Email" value={this.state.user.email}
            onChange={(e, value) => this.onChangeValue("email", e)}
            onBlur={(e, value) => this.onBlurValue("email", e)} />
          {emailErrorMsg}
        </div>
        <div className={"form-group " + ((this.state.ui.password > 0 && this.state.ui.password < 30) ? "has-error" : "") + ((this.state.ui.password >= 30 && this.state.ui.password <= 60) ? "has-warning" : "")}>
          <label>{Localize.L("Password")}</label>
          <input type="text" className="form-control" placeholder="Password" value={this.state.user.password}
            onChange={(e, value) => this.onChangeValue("password", e)} />
          {passwordMsg}
        </div>
        <div className="checkbox">
          <label>
            <input type="checkbox" checked readOnly /> {Localize.L("Consenso al trattamento dei dati EX Art.23 D.LGS N.196/2003")}
        </label>
        </div>
        <hr />
        <div className="form-group">
          <label>{Localize.L("Numero di telefono")} <span style={{ color: "#888", fontWeight: "normal" }}>({Localize.L("opzionale ma apprezzato")})</span></label>
          <input type="text" className="form-control" placeholder="Numero di telefono" value={this.state.user.phone} onChange={(e, value) => this.onChangeValuen("phone", e)} />
        </div>
        <button type="submit" className={"btn btn-lg btn-orange btn-big-enough " + ((this.state.ui.clickedJoinNow && (this.state.ui.isSaving || !this.state.ui.email))?" disabled":"")}
          disabled={this.state.ui.clickedJoinNow && (this.state.ui.isSaving || !this.state.ui.email)}
          onClick={(e) => this.onJoinNow(e)}>{joinBtnText}</button>
        {this.state.ui.isSaving ? <div><i className="fa fa-cog fa-spin fa-fw"></i> <span>{Localize.L("Saving")}...</span></div> : null}
        <div>
          {joinBtnMsg}
        </div>
      </fieldset>
    );
  }
}

export { UserJoin }
